import { render, staticRenderFns } from "./modal-offer-halloween-1.vue?vue&type=template&id=edde3e84"
import script from "./modal-offer-halloween-1.vue?vue&type=script&lang=js"
export * from "./modal-offer-halloween-1.vue?vue&type=script&lang=js"
import style0 from "./modal-offer-halloween-1.vue?vue&type=style&index=0&id=edde3e84&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports